<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-4 pb-12 lg:px-8">
            <div class="bg-gray-50 rounded-2xl px-6 py-16 sm:p-16">
                <div class="max-w-xl mx-auto lg:max-w-none">
                    <div class="text-center">
                        <h2 class="text-2xl font-extrabold tracking-tight text-gray-900">Budujemy nasze przedsiębiorstwo na zaufaniu i spersonalizowanej obsłudze Klienta</h2>
                    </div>
                    <div class="mt-12 max-w-sm mx-auto grid grid-cols-1 gap-y-10 gap-x-8 sm:max-w-none lg:grid-cols-3">
                        <div v-for="incentive in incentives" :key="incentive.name" class="text-center sm:flex sm:text-left lg:block lg:text-center">
                            <div class="sm:flex-shrink-0">
                                <div class="flow-root">
                                    <component :is="incentive.icon" class="w-16 h-16 mx-auto text-indigo-600" aria-hidden="true" />
                                </div>
                            </div>
                            <div class="mt-3 sm:mt-0 sm:ml-6 lg:mt-6 lg:ml-0">
                                <h3 class="text-sm font-medium text-gray-900">
                                    {{ incentive.name }}
                                </h3>
                                <p class="mt-2 text-sm text-gray-500">
                                    {{ incentive.description }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {BadgeCheckIcon, SupportIcon, TruckIcon} from '@heroicons/vue/outline';

const incentives = [
    {
        name: 'Gwarancja jakości i świeżości',
        icon: 'BadgeCheckIcon',
        description: "Od ponad 30 lat oferujemy szeroki asortyment produktów spożywczych i przemysłowych. Wiemy jak szukać produktów wysokiej jakości i dbać o ich trwałość!",
    },
    {
        name: 'Porada i indywidualna obsługa',
        icon: 'SupportIcon',
        description:
            "Oferujemy wsparcie dla Klienta na wszystkich etapach sprzedaży. Nasza obsługa chętnie doradzi przy wyborze produktów, udzieli wsparcia przy pierwszych zakupach, ale także pomoże przy zgłoszeniu reklamacji. ",
    },
    {
        name: 'Dostawa zakupów',
        icon: 'TruckIcon',
        description: "Dostarczamy produkty lokalnie na terenie powiatów bielskiego, żywieckiego i cieszyńskiego oraz na terenie całej Polski i wybranych krajów Unii Europejskiej. Zrealizowaliśmy tysiące zamówień, nasza obsługa dokłada wszelkich starań, aby dostarczać najlepsze produkty w możliwie najkrótszym czasie.",
    },
]

export default {
    name: "QuickHeadings",
    components: {
        BadgeCheckIcon,
        SupportIcon,
        TruckIcon,
    },
    setup() {
        return {
            incentives,
        }
    },
}
</script>
